const UNLOCKED_PREFIX = 'duvpost.pinUnlocked.v1:';
const HIDDEN_PREFIX = 'duvpost.chatHistoryHidden.v1:';
const FAIL_PREFIX = 'duvpost.pinFails.v1:';
export const CHAT_HISTORY_HIDDEN_EVENT = 'duvpost-chat-history-hidden';

let boundUid = '';

function unlockedKey(uid: string): string {
  return `${UNLOCKED_PREFIX}${uid}`;
}

function hiddenKey(uid: string): string {
  return `${HIDDEN_PREFIX}${uid}`;
}

function failKey(uid: string): string {
  return `${FAIL_PREFIX}${uid}`;
}

function emitHiddenChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new Event(CHAT_HISTORY_HIDDEN_EVENT));
}

export function bindChatHistoryHiddenUid(uid: string): void {
  boundUid = uid;
}

export function markAppPinUnlocked(uid: string): void {
  try {
    sessionStorage.setItem(unlockedKey(uid), '1');
  } catch {
    /* private mode */
  }
}

export function isAppPinUnlocked(uid: string): boolean {
  try {
    return sessionStorage.getItem(unlockedKey(uid)) === '1';
  } catch {
    return false;
  }
}

export function clearAppPinUnlocked(uid: string): void {
  try {
    sessionStorage.removeItem(unlockedKey(uid));
  } catch {
    /* */
  }
}

export function hideChatHistory(uid: string): void {
  try {
    localStorage.setItem(hiddenKey(uid), '1');
  } catch {
    /* */
  }
  emitHiddenChanged();
}

export function clearHiddenChatHistory(uid: string): void {
  try {
    localStorage.removeItem(hiddenKey(uid));
  } catch {
    /* */
  }
  emitHiddenChanged();
}

export function isChatHistoryHidden(uid: string): boolean {
  try {
    return localStorage.getItem(hiddenKey(uid)) === '1';
  } catch {
    return false;
  }
}

export function isBoundChatHistoryHidden(): boolean {
  return boundUid ? isChatHistoryHidden(boundUid) : false;
}

export function subscribeChatHistoryHidden(onChange: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const handler = () => onChange();
  window.addEventListener(CHAT_HISTORY_HIDDEN_EVENT, handler);
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(CHAT_HISTORY_HIDDEN_EVENT, handler);
    window.removeEventListener('storage', handler);
  };
}

export function readPinFailState(uid: string): { count: number; untilMs: number } {
  try {
    const raw = sessionStorage.getItem(failKey(uid));
    if (!raw) return { count: 0, untilMs: 0 };
    const o = JSON.parse(raw) as { count?: unknown; untilMs?: unknown };
    const count = typeof o.count === 'number' ? o.count : 0;
    const untilMs = typeof o.untilMs === 'number' ? o.untilMs : 0;
    return { count, untilMs };
  } catch {
    return { count: 0, untilMs: 0 };
  }
}

export function writePinFailState(uid: string, count: number, untilMs: number): void {
  try {
    sessionStorage.setItem(failKey(uid), JSON.stringify({ count, untilMs }));
  } catch {
    /* */
  }
}

export function clearPinFailState(uid: string): void {
  try {
    sessionStorage.removeItem(failKey(uid));
  } catch {
    /* */
  }
}

export function clearAppPinSession(uid: string): void {
  clearAppPinUnlocked(uid);
  clearPinFailState(uid);
}
